import React, { useCallback, useState } from 'react';
import { Modal } from 'antd';
import styles from './styles.module.scss';

const TrainingModal = () => {
    const [open, setOpen] = useState(localStorage.getItem('viewedTrainingModal') !== 'true');

    const closeModal = useCallback(() => {
        localStorage.setItem('viewedTrainingModal', 'true');
        setOpen(false);
    }, []);

    return (
        <Modal open={open} onCancel={closeModal} title='👋 Welcome to the Swiftlane Admin Dashboard!' footer={null} destroyOnClose>
            <p className={styles.description}>
                Let’s get you oriented. This quick video will walk you through the core features—adding users, managing doors, and reviewing
                device status.
            </p>
            <div>
                {/* <iframe
                    className={styles.videoIframe}
                    src='https://www.youtube.com/embed/jQFEjFMwq5E?si=2TF0D82T0nzkJgjP&autoplay=1'
                    title='YouTube video player'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                /> */}
                <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
                    <iframe
                        src='https://player.vimeo.com/video/799516425?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                        frameBorder='0'
                        allow='autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
                        referrerPolicy='strict-origin-when-cross-origin'
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                        title='Swiftlane Administrator Onboarding'
                    />
                </div>
                <script src='https://player.vimeo.com/api/player.js' />
            </div>
            <button type='button' className={styles.skipButton} onClick={closeModal}>
                Skip for now
            </button>
        </Modal>
    );
};

export default TrainingModal;
